
import { makeStyles, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import { IconButton } from "@mui/material";


const useStyles = makeStyles((theme) => ({
    root: {
        height: 70,
        width: '100%',
        background: '#85287e',
        borderRadius: 5,
        transition: '0.3s',
        overflow: 'scroll',
        display: 'flex',
        justifyContent: 'flex-start',
        // gap: 2,
        marginTop: 15,

        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
        '&:hover': {
            boxShadow: '3px 3px 3px #67348d'
        }
    },
    downloadIcon: {
        '&:hover': {
            boxShadow: '3px 3px 3px #7a4e9c',
            border: ' 1px solid #fff',
        },
    }
}))

type cardServicesProps = {
    nomeOpcao: string;
    link: string;
    url?: string;
}
export default function ListaOpcoes({ nomeOpcao, link, url }: cardServicesProps) {
    const classes = useStyles()

    return (
        <CardActionArea className={classes.root} >
            {url &&
                <IconButton className={classes.downloadIcon} onClick={() => window.open(url ?? link, "_blank", "noopener,noreferrer")}>
                    <img src='/img/icones/downloadicon.svg' alt="downloadicon" />
                </IconButton>
            }

            <Link style={{ textDecoration: 'none', border:'1 solid ', width:'100%' }} to={link}>
                <CardContent style={{ padding: 5 }}>
                    <Typography variant="subtitle1" style={{ lineHeight: 1, fontSize: 15, color: '#fff', paddingLeft: 20 }}>
                        {nomeOpcao}
                    </Typography>
                </CardContent>
            </Link>
        </CardActionArea>
    )
}